/**
 * Sector Operations — Stays Guest Requests Service (SO-P119, SO-D207, SO-D209, SO-D299).
 * Client service wrapping callables for guest room requests and staff settings.
 */

import { callable } from './callable'
import type {
  GetGuestRoomFormInput,
  GetGuestRoomFormResult,
  RaiseGuestRequestInput,
  RaiseGuestRequestResult,
  GetGuestRequestStatusInput,
  GetGuestRequestStatusResult,
  GuestStillAProblemInput,
  GuestStillAProblemResult,
  SetPropertyGuestRequestsEnabledInput,
  SetPropertyGuestRequestsEnabledResult,
  ConfirmGuestExtraRequestInput,
  ConfirmGuestExtraRequestResult,
  DeclineGuestExtraRequestInput,
  DeclineGuestExtraRequestResult,
} from '../types/ops'

export async function getGuestRoomForm(
  input: GetGuestRoomFormInput,
): Promise<GetGuestRoomFormResult> {
  return callable<GetGuestRoomFormInput, GetGuestRoomFormResult>(
    'getGuestRoomForm',
    input,
  )
}

export async function raiseGuestRequest(
  input: RaiseGuestRequestInput,
): Promise<RaiseGuestRequestResult> {
  return callable<RaiseGuestRequestInput, RaiseGuestRequestResult>(
    'raiseGuestRequest',
    input,
  )
}

export async function getGuestRequestStatus(
  input: GetGuestRequestStatusInput,
): Promise<GetGuestRequestStatusResult> {
  return callable<GetGuestRequestStatusInput, GetGuestRequestStatusResult>(
    'getGuestRequestStatus',
    input,
  )
}

export async function guestStillAProblem(
  input: GuestStillAProblemInput,
): Promise<GuestStillAProblemResult> {
  return callable<GuestStillAProblemInput, GuestStillAProblemResult>(
    'guestStillAProblem',
    input,
  )
}

export async function setPropertyGuestRequestsEnabled(
  input: SetPropertyGuestRequestsEnabledInput,
): Promise<SetPropertyGuestRequestsEnabledResult> {
  return callable<
    SetPropertyGuestRequestsEnabledInput,
    SetPropertyGuestRequestsEnabledResult
  >('setPropertyGuestRequestsEnabled', input)
}

export async function confirmGuestExtraRequest(
  input: ConfirmGuestExtraRequestInput,
): Promise<ConfirmGuestExtraRequestResult> {
  return callable<ConfirmGuestExtraRequestInput, ConfirmGuestExtraRequestResult>(
    'confirmGuestExtraRequest',
    input,
  )
}

export async function declineGuestExtraRequest(
  input: DeclineGuestExtraRequestInput,
): Promise<DeclineGuestExtraRequestResult> {
  return callable<DeclineGuestExtraRequestInput, DeclineGuestExtraRequestResult>(
    'declineGuestExtraRequest',
    input,
  )
}
